import type { SelectItemProps } from '@sola/ark-core/molecules/select/select.tsx';
import {
  COVER_CATEGORY_OPTIONS,
  GIFT_IDS,
} from '@sola/schema/lib/honor-card-constants.ts';

export const coverCategories =
  COVER_CATEGORY_OPTIONS as unknown as SelectItemProps[];

export const coverNumbers = Array.from({ length: 15 }, (_, i) => i + 1);

export const coverCategoryTitleColor: Record<string, string> = {
  'merry-christmas': '#506963',
  birthday: '#6BBBDC',
  'thank-you': '#0096D1',
  'in-memory': '#6BBBDC',
  easter: '#A6A474',
  'mothers-day': '#E5A397',
  'fathers-day': '#215FAC',
  'in-your-honor': '#BEDEB5',
  'thinking-of-you': '#0167B1',
};

export const getBackgroundSrc = (category: string, number: number): string =>
  `https://compassionmedia.com/card-maker/background-${category}-${number}.webp`;

export const giftOptionValues: string[] = [...GIFT_IDS];
